// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st3{fill:#fff}.st4{fill:#fbc942}.st5{fill:#bd9b37}.st6{fill:#9ba068}.st7{fill:#707633}.st8{fill:#006748}.st11{fill:#f7c740}.st12{fill:#0c72a6}.st13{fill:#f8a952}.st15{fill:#231f20}.st16{fill:#0b8388}.st17{fill:#8bbdbe}.st18{fill:#05534e}.st37{fill:#f8c73e}.st38{fill:#77722f}.st39{fill:#a7ab71}.st40{fill:#949457}.st41{fill:#ae6f2a}.st42{fill:#fff200}.st45{fill:#4c2915}.st46{fill:#8e4520}.st47{fill:#d1a467}.st48{fill:#aa6c2a}.st49{fill:#daac6d}.st50{fill:#8f4620}", ""]);
// Exports
module.exports = exports;
